import { EMPTY_ARRAY, EMPTY_OBJECT } from 'utils/emptyConstants'

export const selectConnectWise = (state) => state.connectWise || EMPTY_OBJECT

export const selectConnectWiseCurrentStep = (state) => selectConnectWise(state).currentStep

export const selectConnectWiseConnection = (state) =>
  selectConnectWise(state).connection || EMPTY_OBJECT

export const selectConnectWiseAllCompanies = (state) =>
  selectConnectWise(state).allCompanies || EMPTY_ARRAY

export const selectConnectWiseUnmappedCompanies = (state) =>
  selectConnectWise(state).unmappedCompanies || EMPTY_ARRAY
export const selectConnectWiseProductMappings = (state) =>
  selectConnectWise(state).productMappings || EMPTY_ARRAY

export const selectConnectWiseTicketBoard = (state) =>
  selectConnectWise(state).ticketBoard || EMPTY_OBJECT

export const selectConnectWiseFieldErrors = (state) =>
  selectConnectWise(state).fieldErrors || EMPTY_OBJECT

export const selectTestConnectionLoading = (state) => selectConnectWise(state).testConnectionLoading

export const selectTestConnectionError = (state) => selectConnectWise(state).testConnectionError

export const selectTestConnectionSuccess = (state) => selectConnectWise(state).testConnectionSuccess

export const selectConnectWiseMappedCompanies = (state) =>
  selectConnectWise(state).mappedCompanies || EMPTY_ARRAY

export const selectConnectWiseAllCompaniesCount = (state) =>
  selectConnectWise(state).allCompaniesCount || 0

export const selectConnectWiseUnmappedCompaniesCount = (state) =>
  selectConnectWise(state).unmappedCompaniesCount || 0

export const selectConnectWiseCompanies = (state) =>
  selectConnectWise(state).companies || EMPTY_ARRAY

export const selectConnectWiseProducts = (state) => selectConnectWise(state).products || EMPTY_ARRAY

export const selectConnectWiseServiceBoards = (state) =>
  selectConnectWise(state).serviceBoards || EMPTY_ARRAY

export const selectConnectWiseBoardStatuses = (state) =>
  selectConnectWise(state).boardStatuses || EMPTY_ARRAY

export const selectConnectWisePriorities = (state) =>
  selectConnectWise(state).priorities || EMPTY_ARRAY

export const selectConnectWiseIsSubmitting = (state) => selectConnectWise(state).isSubmitting

export const selectConnectWiseSubmitError = (state) => selectConnectWise(state).submitError

export const selectConnectWiseAllCompanyLoader = (state) =>
  selectConnectWise(state).allCompanyLoader

export const selectConnectWiseUnmappedCompanyLoader = (state) =>
  selectConnectWise(state).unmappedCompanyLoader

export const selectConnectWisePage = (state) => selectConnectWise(state).page || 1

export const selectConnectWiseAgreementsLoaders = (state) =>
  selectConnectWise(state).agreementsLoaders || EMPTY_ARRAY

export const selectConnectWiseIsConnectionEditMode = (state) =>
  selectConnectWise(state).isConnectionEditMode || false

export const selectConnectWiseCompaniesSearchLoader = (state) =>
  !!selectConnectWise(state).companiesSearchLoader

export const selectConnectWiseCompaniesSearchHasMore = (state) =>
  !!selectConnectWise(state).companiesSearchHasMore

export const selectConnectWiseCompaniesSearchPage = (state) =>
  selectConnectWise(state).companiesSearchPage || 1

export const selectConnectWiseCompaniesSearchQuery = (state) =>
  selectConnectWise(state).companiesSearchQuery || ''
